import Nprogress from 'nprogress'

import store from '@/store/store'

export default function retailerPolicyControl(to, from, next) {
  store.dispatch('retailerAuth/getUser').then(() => {
    let user = store.state['retailerAuth'].user
    const policyPath = '/retailer/policy'

    if (!user.retailer.is_policy_accepted && user.retailer.sales_channels.length > 0 && to.path !== policyPath) {
      if (from.path === policyPath) {
        Nprogress.done()
      }
      return next({
        name: 'retailer.policy'
      })
    } else if (user.retailer.is_policy_accepted && to.path === policyPath) {
      return next({
        name: 'retailer.dashboard'
      })
    } else {
      return next()
    }
  })
}
